module.exports = "pegasus_template/assets/themelp1/health/101.png";